import AclName from '../AclName';

export default [
  AclName.StaffAccessAll,
  AclName.FilesPageFilesList,
  AclName.BookkeepingPageDeclarationsVatList,
  AclName.BookkeepingPageDeclarationsPitList,
  AclName.BookkeepingPageZusCompanySettlementsList,
  AclName.CrmPageMyAgreementsList,
  AclName.BookkeepingInvoicesAccessAll,
  AclName.BookkeepingEvidencesAccessAll,
  AclName.CrmPageMyAgreementsList,

  AclName.CrmPageBillingList,
  AclName.CrmPageBillingSettle,
  AclName.CrmPageBankingOperationsList,
  AclName.CrmPageBankingOperationsSettle,
  AclName.CrmPageMailingList,
  AclName.CrmPageMailingStepper,
  AclName.CrmBtnMailingDelete,
  AclName.CrmBtnMailingEdit,
  AclName.CrmBtnMailingSendNow,
  AclName.MailingSettingsBtnSave,
];
